import { setRefererIdInLocalStorage } from './refererManagement';
import RefererService, { RefererServiceResponse } from './service';

interface PageInformationParam {
  pageType: string;
  requesterType: string;
}

interface RefererSdkResponse {
  refererId: string;
  rawRefererId: string;
  trackingCampaign: string;
  trackingCategory: string;
  trackingChannel: string;
}

const isBot = (requesterType: string): boolean => {
  enum BotValues {
    OTHER_BOT = 'bot',
    SEA_BOT = 'sea',
    SEO_BOT = 'seo',
  }

  return Object.values<string>(BotValues).includes(requesterType);
};

async function main(
  manomanoApiUrl: string,
  { pageType, requesterType }: PageInformationParam,
  cookieDisabled = false
): Promise<RefererSdkResponse | undefined> {
  if (!isBot(requesterType)) {
    const refererService = new RefererService(manomanoApiUrl);

    refererService.removeInvalidCurrentRefererId();

    return refererService
      .getTrackingInfo(pageType, cookieDisabled)
      .then(
        ({
          refererId,
          rawRefererId,
          trackingCampaign,
          trackingCategory,
          trackingChannel,
        }: RefererServiceResponse) => {
          setRefererIdInLocalStorage(refererId);

          return {
            refererId,
            rawRefererId,
            trackingCampaign,
            trackingCategory,
            trackingChannel,
          };
        }
      )
      .catch(() => {
        refererService.removeInvalidCurrentRefererId();

        return undefined;
      });
  }
}

export default main;
